import { FormEvent, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Bell } from 'react-feather';
import Screen from '../Layouts/Screen/Screen';
import Spinner from '../../global-components/src/components/spinner/spiner';
import { useAuth, useMessage } from '../../global-components/src';
import { errorMessage } from '../../global-components/src/utils/text';
import { api } from '../../services/api';
import './moderator-actions.css';

interface BroadcastPushResponse {
    message?: string;
}

const BroadcastPush = () => {
    const { token } = useAuth();
    const { setMessage } = useMessage();
    const [title, setTitle] = useState('Paçoca');
    const [text, setText] = useState('');
    const [sending, setSending] = useState(false);

    const submitPush = async (event: FormEvent) => {
        event.preventDefault();
        if (!window.confirm('Enviar este push para todos os usuários do Paçoca?')) return;

        setSending(true);
        try {
            const { data } = await api(token).post<BroadcastPushResponse>('/pacoca-tools/push', {
                title: title.trim(),
                text: text.trim(),
            });
            setMessage(data.message ?? 'Push agendado.', 'success');
            setText('');
        } catch (error) {
            setMessage(errorMessage(error), 'error');
        } finally {
            setSending(false);
        }
    };

    return (
        <Screen title="Push para todos" paddingTopTitle>
            <Helmet>
                <title>Paçoca - Push para todos</title>
            </Helmet>

            <div className="moderator-action-page">
                <section className="moderator-action-card">
                    <div className="moderator-action-heading">
                        <div>
                            <h2><Bell size={21} /> Push para todos</h2>
                            <p>O envio é processado em segundo plano e usa o cache de tokens para não travar a API.</p>
                        </div>
                    </div>

                    <form className="moderator-push-form" onSubmit={submitPush}>
                        <div className="moderator-action-field">
                            <label htmlFor="push-title">Título</label>
                            <input
                                id="push-title"
                                className="form-control"
                                required
                                maxLength={100}
                                value={title}
                                onChange={event => setTitle(event.target.value)}
                            />
                            <small>{title.length}/100</small>
                        </div>

                        <div className="moderator-action-field">
                            <label htmlFor="push-text">Texto</label>
                            <textarea
                                id="push-text"
                                className="form-control"
                                required
                                maxLength={380}
                                rows={5}
                                value={text}
                                onChange={event => setText(event.target.value)}
                                placeholder="Mensagem que aparecerá na notificação"
                            />
                            <small>{text.length}/380</small>
                        </div>

                        <button className="btn btn-danger moderator-send-button" type="submit" disabled={sending}>
                            {sending ? <Spinner /> : <Bell size={17} />}
                            Agendar push para todos
                        </button>
                    </form>
                </section>
            </div>
        </Screen>
    );
};

export default BroadcastPush;
